import React from 'react';
import { motion } from 'framer-motion';
import { Search, Target, Sprout, AlertCircle } from 'lucide-react';
export function DiagnosticSection() {
  return <section id="diagnostico" className="py-24 relative overflow-hidden bg-[#0D1B3E]" data-id="element-31">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-32">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-gold to-transparent" data-id="element-33"></div>
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-gold to-transparent" data-id="element-34"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-35">
        {/* PRE-DIAGNÓSTICO */}
        <div className="text-center mb-16" data-id="element-36">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-gold font-semibold tracking-wider text-sm uppercase mb-4 block" data-id="element-37">
            Antes de comenzar — Conoce tu punto de partida
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-serif text-4xl md:text-5xl text-cream mb-6" data-id="element-38">
            Completa tu Diagnóstico RenuevaTE_90 gratuito
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-cream/80 text-lg max-w-3xl mx-auto mb-12 font-light" data-id="element-39">
            Este diagnóstico nos ayuda a conocer tu momento actual, tus
            objetivos, tus hábitos, tus retos y el nivel de acompañamiento que
            necesitas para asegurar tu éxito.
          </motion.p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-40">
            {[{
            icon: Search,
            text: 'Claridad sobre tu estado actual'
          }, {
            icon: Target,
            text: 'Orientación hacia un plan inicial personalizado'
          }, {
            icon: Sprout,
            text: 'Base para resultados sostenibles a largo plazo'
          }].map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + idx * 0.1
          }} className="flex flex-col items-center p-6 bg-cream/5 rounded-2xl border border-gold/20" data-id="element-41">
                <item.icon className="w-10 h-10 text-gold mb-4" data-id="element-42" />
                <p className="text-cream font-medium" data-id="element-43">{item.text}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} className="flex items-start gap-3 bg-cream/10 p-4 rounded-lg border border-cream/20 max-w-2xl mx-auto text-left" data-id="element-44">
            <AlertCircle className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-45" />
            <p className="text-cream/70 text-sm" data-id="element-46">
              <strong className="text-cream" data-id="element-47">Nota importante:</strong> Este
              diagnóstico no sustituye una consulta médica. Consulta con tu
              profesional de salud antes de iniciar cualquier programa de
              bienestar.
            </p>
          </motion.div>
        </div>

        {/* EMBED DEL FORMULARIO JOTFORM */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-cream rounded-2xl p-4 md:p-8 shadow-2xl border border-gold/30 relative" data-id="element-48">
          <div className="text-center mb-8" data-id="element-49">
            <h3 className="font-serif text-2xl md:text-3xl text-navy mb-2" data-id="element-50">
              📋 Diagnóstico RenuevaTE_90
            </h3>
            <p className="text-navy/60 text-sm font-medium tracking-widest uppercase" data-id="element-51">
              Despertar del cuerpo · Nutrición · Bienestar · Mente · Espíritu
            </p>
          </div>

          <div className="w-full bg-white rounded-xl overflow-hidden shadow-inner min-h-[800px]" data-id="element-52">
            {/* JOTFORM EMBED CODE */}
            <iframe id="JotFormIFrame-261346641401045" title="RenuevaTE_90 Wellness Diagnostic" src="https://form.jotform.com/261346641401045" style={{
            width: '100%',
            height: '800px',
            border: 'none'
          }} scrolling="yes" data-id="element-53"></iframe>
          </div>
        </motion.div>

        {/* POST-DIAGNÓSTICO */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center mt-16" data-id="element-54">
          <p className="text-cream/90 text-xl font-serif italic mb-8" data-id="element-55">
            "Una vez que envíes tu diagnóstico, recibirás orientación
            personalizada en 24–48 horas."
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-56">
            <p className="text-cream/60 text-sm uppercase tracking-widest" data-id="element-57">
              ¿Ya completaste el diagnóstico?
            </p>
            <a href="#inscripcion" className="bg-transparent border-2 border-gold text-gold hover:bg-gold hover:text-navy font-bold py-3 px-8 rounded-full transition-all duration-300" data-id="element-58">
              Continuar a la Inscripción
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}